<template lang="pug">
v-dialog(:value="!!value" @input="close" fullscreen)
  v-card(v-if="pv")
    v-card-title.primary
      span.title.white--text Patientenverfügung
      v-spacer
      v-btn(dark icon @click="close"): v-icon close
    v-card-text
      v-container(grid-list-xl)
        v-card.mb-3
          v-card-text
            v-layout(wrap)
              v-flex(xs12 sm2): v-text-field(label="ID" v-model="pv.id" disabled)
              v-flex(xs12 sm5): v-text-field(label="Vorname" v-model="pv.vorname" disabled)
              v-flex(xs12 sm5): v-text-field(label="Nachname" v-model="pv.nachname" disabled)
              v-flex(xs12 sm6): v-select(label="Dringlichkeit" row :items="dringlichkeiten" v-model="pv.dringlichkeit" disabled)
              v-flex(xs12 sm6): v-text-field(label="Betrag" v-model="pv.betrag" disabled)
              v-flex(xs12 sm8): radio-group(label="Status" row :items="staten" v-model="pv.status")
              v-flex(xs12 sm4): v-btn(@click="saveStatus(pv.status)" :disabled='pv.status === pvStatusOld') Status Speichern
              v-flex(xs12 md4 xl4)
                v-layout(wrap)
                  v-flex(xs12)
                    v-btn-toggle(v-model="border")
                      v-btn(active-class="primary--text"): v-icon format_align_justify
                    v-btn-toggle(v-model="bg" mandatory)
                      v-btn(flat class="grey lighten-4" active-class="primary--text"): v-icon view_agenda
                      v-btn(flat class="grey lighten-1" active-class="primary--text"): v-icon view_agenda
                      v-btn(flat class="grey" active-class="primary--text"): v-icon view_agenda
                      v-btn(flat class="grey darken-3" active-class="primary--text"): v-icon view_agenda
                  v-flex(xs12): v-btn(@click="pvBearbeiten = true") Bearbeiten
              v-flex(xs12 md8)
                v-layout(wrap)
                  v-flex(xs12 sm4): v-btn(@click="settings = preview.id" :disabled="!preview") <v-icon>settings</v-icon> Einstellungen
                  v-flex(xs12 sm4): v-checkbox(label="Bezeugung" v-model="bezeugung")
                  v-flex(xs12 sm4): v-text-field(label="Ausdrucke" v-model="ausdrucke" hide-details type="number")
                  v-flex(xs12 sm4): v-checkbox(label="PDF nicht speichern" v-model="pdfNichtSpeichern")
                  v-flex(xs12 sm4): v-btn(@click="print($event, true)" :loading="printingPDF" :disabled="!preview || printing" block) PDF
                  v-flex(xs12 sm4): v-btn(@click="print($event)" :loading="printing" :disabled="!preview || printingPDF" block) Drucken
              v-flex(xs12): v-alert(:value="!!printError" type="error") {{printError}}
        v-card
          v-card-text
            template(v-for="vorlage in druckVorlagen")
              v-btn(@click="preview = vorlage" :input-value="preview === vorlage" :color="vorlagenButtonColor(vorlage.name)") {{ vorlage.name }}
      v-dialog(v-model="pvBearbeiten")
        v-card
          v-card-text
            v-flex(xs6 sm5): v-text-field(label="Vorname" v-model="pv.vorname")
            v-flex(xs12 sm5): v-text-field(label="Nachname" v-model="pv.nachname")
            v-flex(xs12 sm6): v-select(label="Dringlichkeit" row :items="dringlichkeiten" v-model="pv.dringlichkeit")
            v-flex(xs12 sm6): v-text-field(label="Betrag" v-model="pv.betrag" :error-messages="gqlErrorsFor('patientenverfuegungUpdate', 'betrag')")
            template(v-for="pvDatas in pvdataBearbeiten")
              v-flex(xs12 sm6 v-if="pvDatas[1]==='ja' || pvDatas[1]==='nein'"): v-checkbox(:label="pvDatas[0]" @change="pvDatas[1]=$event" true-value="ja" false-value="nein" :input-value="pvDatas[1]")
              v-flex(xs12 sm6 v-else-if="typeof(pvDatas[1])==='string'"): v-text-field(:label="pvDatas[0]" :value="pvDatas[1]" @input="pvDatas[1]=$event")
              v-flex(xs12 sm6 v-else): v-text-field(:label="pvDatas[0]" :value="pvDatas[1]" @input="pvDatas[1]=$event" disabled)
            v-flex(xs12 sm4): v-btn(@click="savePvData(pv)") Speichern

    template(v-if="preview")
      extra-druck-vorlagen-render(:bg="bg" :bezeugung="bezeugung" :pdfNichtSpeichern="pdfNichtSpeichern" :border="border === 0" :value="preview" :anzahl="+ausdrucke" :item="pv" ref="render" :url2pdfHost="url2pdfHost" :druckvorlagenName="preview ? preview.name : null")
    extra-druck-vorlagen-settings(v-model="settings")
    .pb-3

</template>

<script>
import ExtraDruckVorlagenPage from "../extra-druck-vorlagen-page.vue"
import ExtraDruckVorlagenRender from "../extra-druck-vorlagen-render.vue"
import ExtraDruckVorlagenSettings from "../extra-druck-vorlagen-settings.vue"
import gql from 'graphql-tag'
import GraphqlErrorObject from '../../../mixins/graphql-error-object.js'

export default {
  props: {
    value: String,
    url2pdfHost: String,
  },
  components: {
    ExtraDruckVorlagenPage,
    ExtraDruckVorlagenRender,
    ExtraDruckVorlagenSettings,
  },
  mixins: [GraphqlErrorObject],
  data() {
    return {
      pvStatusOld: null,
      printError: null,
      printing: false,
      printingPDF: false,
      pv: null,
      preview: null,
      settings: null,
      pvBearbeiten: null,
      bg: 3,
      border: 0,
      bezeugung: false,
      pdfNichtSpeichern: false,
      ausdrucke: 2,
      html: null,
      printBG: null,
      pageWidth: 14.8,
      pageHeight: 10.5,
      dringlichkeiten: [
        { text: "Normal", value: "normal" },
        { text: "Dringend", value: "dringend" },
      ],
      staten: [
        { text: "Neu", value: "neu" },
        { text: "In Bearbeitung", value: "in_bearbeitung" },
        { text: "Abgeschlossen", value: "abgeschlossen" },
        { text: "test", value: "test" },
      ],
    }
  },
  apollo: {
    currentUser: {
      query: gql`query ExtradruckVorlagenEditVue {
        currentUser {
          id
          vorname
          nachname
        }
      }`
    },
    patientenverfuegungen: {
      query: gql`query PvEditVue($id: ID) {
        patientenverfuegungen(where: { id: $id }) {
          id
          status
          vorname
          nachname
          dringlichkeit
          betrag
          data
          rechnungsnummer
          datRechn
        }
      }`,
      variables() {
        return { id: this.value }
      },
      update(response) {
        this.pv = response.patientenverfuegungen[0]
      },
      skip() {
        return !this.value
      }
    },
    druckVorlagen: {
      query: gql`query PvEditVueVorlagen {
        druckVorlagen(order: "slug:asc", where: { art: "pv" }) {
          id
          name
          slug
          pages {
            backgroundName
            backgroundUrl
            format
            height
            width
            texts {
              x
              y
              width
              height
              size
              lineHeight
              type
              text
              template
              options
            }
          }
        }
      }`
    }
  },
  watch: {
    pv(pv) {
      this.pvStatusOld = pv && pv.status
      this.bg = 3
      this.border = 1
      this.ausdrucke = 2
      this.bezeugung = false
      if (this.druckVorlagen) {
        this.preview = this.druckVorlagen[0]
      } else {
        this.preview = null
      }
    },
    druckVorlagen(vorlagen) {
      if (!this.preview && vorlagen) {
        this.preview = vorlagen[0]
      }
    },
  },
  computed: {
    pvdata() {
      const pv = this.pv
      if (pv && pv.data) {
        return JSON.parse(pv.data)
      }
    },
    pvdataBearbeiten() {
      const blacklist = ["vorname", "nachname", "dringlichkeit", "gebuehr", "raw", "entry_token"]
      return Object.entries(this.pvdata).filter(entri => {
        if(blacklist.indexOf(entri[0]) === -1) {
          return entri
        }
      })
    }
  },
  methods: {
    vorlagenButtonColor(vorlagenName) {
      const pvdata = this.pvdata
      let vorlage = vorlagenName && vorlagenName.toLowerCase()
      if (vorlagenName === "Betreuungsverfügung") {
        vorlage = "betreuungsverfuegung"
      } else if (vorlagenName === "Gesundheitsvollmacht") {
        vorlage = "gesundheitsvollmacht"
      } else if (vorlagenName === "Vorsorgevollmacht") {
        vorlage = "vorsorgevollmacht"
        if(pvdata.bev1_vorname) {
          return 'green lighten-4'
        } else {
          return 'red lighten-4'
        }
      } else {
        return ''
      }
      if (pvdata[vorlage] && pvdata[vorlage][0] === "ja") {
        return 'green lighten-4'
      } else {
        return 'red lighten-4'
      }
    },
    savePvData(pv) {
      this.$apollo.mutate({
        mutation: gql`mutation (
          $id: ID!
          $vorname: String
          $nachname: String
          $betrag: String
          $dringlichkeit: String
          $dataUpdate: String
        ) {
          patientenverfuegungUpdate (id: $id, vorname: $vorname, nachname: $nachname, betrag: $betrag, dringlichkeit: $dringlichkeit, dataUpdate: $dataUpdate){
            id
            vorname
            nachname
            betrag
            dringlichkeit
            data
          }
        }`,
        variables: {
          id: this.value,
          vorname: pv.vorname,
          nachname: pv.nachname,
          betrag: pv.betrag,
          dringlichkeit: pv.dringlichkeit,
          dataUpdate: JSON.stringify(this.pvdataBearbeiten)
        },
      }).then((response) => {
        if (response) {
          this.$apollo.queries.patientenverfuegungen.refetch()
        }
        else {
          alert('Ein Fehler is aufgetreten.')
        }
        this.pvBearbeiten = false
      }, (error) => {
        this.gqlAddErrors(error)
      })
    },
    saveStatus(status){
      this.$apollo.mutate({
        mutation: gql`mutation (
          $id: ID!
          $status: String
        ) {
          patientenverfuegungUpdate (id: $id, status: $status){
            id
            status
          }
        }`,
        variables: {
          id: this.value,
          status
        },
       }).then((response) => {
        if (response) {
          this.pvStatusOld = response.data.patientenverfuegungUpdate.status
        } else {
          alert('Ein Fehler is aufgetreten.')
        }
      })
    },
    close() {
      this.$emit("input", null)
      this.printError = null
    },
    async print(event, pdf) {
      const render = this.$refs.render
      this.printError = null
      if (pdf) {
        this.printingPDF = true
      } else {
        this.printing = true
      }
      try {
        window.printed = await render.print({ downloadPdf: pdf, ctrlKey: event.ctrlKey })
      } catch(error) {
        this.printError = "Drucken Fehlgeschlagen"
      } finally {
        if (pdf) {
          this.printingPDF = false
        } else {
          this.printing = false
        }
      }
    },
  }
}
</script>
